// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__uxCJ9","header":"MergedInvoice_header__1rSdz"};